<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1 v-if="strankaid">Uredi stranko</h1>
        <h1 v-else>Dodaj stranko</h1>
      </div>
       
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">


<div class="">
<form @submit.prevent="handleSubmit" class="k-form">
            <div class="form-group">
                  <div class="km-widget km-buttongroup k-widget k-button-group">
                <button  type="button" class="k-button k-primary" @click="saveData" :disabled="!saveEnabled" >Shrani</button>
                <button type="button" class="k-button k-primary" @click="nazaj" >Nazaj</button>
               </div>
             </div>

   
    <div class="display-flex pt-1">

   

    
             <div>
            <fieldset class="left-border-for-children ">
                 <div class="form-fieldset-header">
            <h2 >Stranka</h2>
        </div>
         <!--<label for="jeaktivna" class="k-form-field k-checkbox-field">
                <span>Je v kontroli (aktivna)</span>
            <input type="checkbox"  v-model="pridelovalec.jeaktivna"  name="jeaktivna" id="jeaktivna" class="k-checkbox" />
        </label>
      -->
            <label for="emso" class="k-form-field">
                <span>Emšo/mšo</span>
                  <div class="display-flex">
                <input type="text" v-model="pridelovalec.mso"   @change="dataChange" placeholder="EMŠO/MŠO" name="mso" class="k-textbox"/>
                  <span  v-if="!strankaid" class="input-icon-search"  @click="iscirkg(pridelovalec.mso,'emso')"><font-awesome-icon icon="search"/></span>
                    </div>  
            </label>
             <label for="ds" class="k-form-field">
                <span>Davčna številka</span>
                  <div class="display-flex">
                <input type="text" v-model="pridelovalec.davcnastevilka"  @change="dataChange" placeholder="Davčna številka" name="davcnastevilka" class="k-textbox"/>
                  <span v-if="!strankaid" class="input-icon-search"  @click="iscirkg(pridelovalec.davcnastevilka,'ds')"><font-awesome-icon icon="search"/></span>
                    </div>  
            </label>

             <label for="msoMaticna" class="k-form-field">
                <span>MŠO matičnega podjetja</span><br>
                <span>(če vstavljamo dislocirano enoto)</span>
                
                  <div class="display-flex">
                <input type="text" v-model="pridelovalec.maticnaStranka"  @change="dataChange" placeholder="MŠO (XXXXXXX000)" name="msoMaticna" class="k-textbox"/>
                    </div>  
            </label>
            </fieldset>
        </div>

            <div>
            <fieldset class="left-border-for-children">
                 <div class="form-fieldset-header">
                    <h2 >Sheme</h2>
                </div>
                <div>
                <div :style="{ display: 'inline-block' }">
                    Sezona
                    <br />
                    <dropdownlist
                :data-items="sezone"
               
                @change="sezonaChange"
                :value="sezona"
            />
                </div>
                </div>
         <div class="k-form-field">
                <span>Vključenost v sheme v izbrani sezoni</span>
            <kendo-multiselect 
                        :value="izbraneSheme"
                        :data-items="sheme"
                        :data-item-key="'kratica'"
                        :text-field="'kratica'"
                        @change="spremeniShemo"
                        :placeholder="'Izberi sheme'"
                        :messages="multiselectmessages"
                        :filterable="true"
                        :auto-width="true"
                      
                        >
            </kendo-multiselect>
        </div>
        </fieldset>
        </div>

           <div>
            <fieldset class="left-border-for-children">
                 <div class="form-fieldset-header">
            <h2 >Kmetija</h2>
        </div>
            <label for="kmgmid" class="k-form-field">
                <span>KMGMID</span>
                <div class="display-flex">
                <kinput type="text" pattern="\d{9}" v-model="pridelovalec.kmgmid" placeholder="KMGMID" @change="dataChange" name="kmgmid" id="kmgmid"/>
                     <span v-if="!strankaid" class="input-icon-search" @click="iscirkg(pridelovalec.kmgmid,'kmgmid')"><font-awesome-icon  icon="search"/></span>
                </div>
            </label>
            <!--
            <label for="naslov" class="k-form-field">
                <span>Naslov</span>
                <input type="text" disabled v-model="pridelovalec.naslovkmg" placeholder="Naslov" name="naslov" id="naslov" class="k-textbox" />
            </label>
            <div class="k-form-field display-flex">
            <label for="postnastevilka">
                <span>Poštna številka</span>
                <input type="text" v-model="postnastevilkakmg"  disabled placeholder="Poštna številka" name="postnastevilka" id="postnastevilka" class="k-textbox" />
            </label>
            <label for="posta" class="flex-grow-1" >
                <span>Pošta</span>
                <input type="text" v-model="postakmg" placeholder="Pošta" disabled name="posta" id="posta" class="k-textbox" />
            </label>
           
        </div> -->
        
            </fieldset>
    </div>    
           </div>
           
           <div style="margin-top:2rem">
             <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
                <h2 >Kontakti</h2>
                <button class="ml-1 k-button k-primary" @click="dodajkontakt()">Dodaj</button>
            </div>
            
            <div class="display-flex pt-1" style="flex-wrap:wrap;gap: 0.5rem;">
            <fieldset style="border:1px solid green;" v-for="(kontakt,index) in pridelovalec.kontakt" :key="index">
                <div class="display-flex" style="align-items:center;justify-content:space-between">
             <div >
            <input class="form-check-input" v-model="kontakt.glavni"  type="checkbox" :id="'glv_chk_'+index">
            <label class="form-check-label" :for="'glv_chk_'+index" >
                   Privzeti kontakt
            </label>
              </div>
                     <button class="ml-1 k-button k-error" @click="brisikontakt(index)">Briši</button>
      
    </div>
             <label for="vloga" class="k-form-field">
                <span>Vloga</span>
                 <dropdownlist
                 :default-value="'kontakt'"
                :data-items="vlogakontakta"
               v-model="kontakt.vloga"
               
            />
               
            </label>
            <label for="ime" class="k-form-field">
                <span>Naziv</span>
                <input type="text" v-model="kontakt.naziv"  placeholder="Naziv" name="ime" class="k-textbox" />
            </label>
            <label for="naslovnosilca" class="k-form-field">
                <span>Naslov</span>
                <input type="text" v-model="kontakt.naslov" placeholder="Naslov"  name="naslovnosilca" class="k-textbox" />
            </label>
           <div class="k-form-field display-flex">
            <label for="postnastevilkanosilca">
                <span>Poštna številka</span>
                <input type="text" v-model="kontakt.postnastevilka"  placeholder="Poštna številka" name="postnastevilkanosilca" class="k-textbox" />
            </label>
            <label for="postanosilca" class="flex-grow-1" >
                <span>Pošta</span>
                <input type="text" v-model="kontakt.posta"  placeholder="Pošta" name="postanosilca" class="k-textbox" />
            </label>
            </div>
            <div class="k-form-field display-flex">
            <label for="kodadrzave">
                <span>Koda države</span>
                <input type="text" v-model="kontakt.kodadrzave"  placeholder="Koda države" name="kodadrzave" class="k-textbox" />
            </label>
            <label for="drzava" class="flex-grow-1" >
                <span>Država</span>
                <input type="text" v-model="kontakt.drzava"  placeholder="Država" name="drzava" class="k-textbox" />
            </label>
            </div>
          <label for="telefonnosilca" class="k-form-field">
                <span>Telefon</span>
                <input type="text" v-model="kontakt.telefon"  placeholder="Telefon" name="telefonnosilca" class="k-textbox" />
            </label>
            <label for="emailnosilca" class="k-form-field">
                <span>E-pošta</span>
                <input type="text" v-model="kontakt.email"  placeholder="Email" name="emailnosilca" class="k-textbox"  />
            </label>
            <label for="spletnastran" class="k-form-field">
                <span>Spletna stran</span>
                <input type="text" v-model="kontakt.spletnastran"  placeholder="Spletna stran" name="spletnastran" class="k-textbox" />
            </label>
            <label for="spletnatrgovina" class="k-form-field">
                <span>Spletna trgovina</span>
                <input type="text" v-model="kontakt.spletnatrgovina"  placeholder="Spletna trgovina" name="spletnatrgovina" class="k-textbox" />
            </label>
            </fieldset>
           </div>

           </div>


        </form>
    </div>
    </div>
    </div>

</template>

<script>
/*
Loči med dodaj in uredi...
*/
import { mapState, mapActions,mapMutations } from 'vuex'
//import { DatePicker } from '@progress/kendo-dateinputs-vue-wrapper';
import { NumericTextBox } from '@progress/kendo-inputs-vue-wrapper';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { pridelavaService } from '../services/pridelava.service';
import { Input } from '@progress/kendo-vue-inputs';
import Vue from 'vue';

export default {
     components: {
  //  'kendo-datepicker': DatePicker,
    'kendo-multiselect': MultiSelect,
    'dropdownlist': DropDownList,
    'kinput':Input,
    'kendo-numerictextbox': NumericTextBox,
  },
    props:['strankaid'],
    data () {
        return {
             dataSezona:this.sezona,
            sezona:this.$trenutnasezona,
             dataValid:true,
             iskanjeError:false,
            multiselectValue:[],ime:"",priimek:"",telefon:"",email:"",opomba:"",postnastevilkakontakt:"",postakontakt:"",postnastevilkanosilec:"",postnanosilec:"",naslovkontakt:"",priimekkontakt:"",postanosilca:"",postnastevilkanosilca:"",kontrolnastevilka:"",
            emailnosilca:"",telefonnosilca:"",
            statusDolocen: new Date(),
            izbranStatus: {"value":0,"text":"Nedoločen"},
            password: '',
            submitted: false,
            vlogakontakta:['kontakt','sedež','nosilec kmg','kmetija (kmg)','nosilec dopolnilne dejavnosti na kmg'],
            multiselectmessages: 
            {
            "singleTag": "izbrani elementi",
            "clear": "Počisti",
            "deleteTag": "Izbriši",
            "noData": "Ni podatkov"
            },
           
            status:[],shemaValue:[{kratica:"A"},{kratica:"B"},{kratica:"C"},{kratica:"D"}],
            testShema:["A","B","C"]
        }
    },
    computed: {
        ...mapState('pridelava', ['pridelovalec']),
        //sezone v katerih lahko piše!
        ...mapState('users', ['sezonePisanje','sheme']),
        ...mapState('sifrant', ['sifrant']),
        ...mapState('alert', ['type']),
        saveEnabled(){
            return true;//!this.iskanjeError&&this.dataValid;
          //return (this.dataValid)&&(this.type!='k-notification-error');
        },
        sezone:
        {
           get() {

             if (!this.pridelovalec.sheme)
                return this.sezonePisanje.map(s=>s.sezona);

            let sezone=this.pridelovalec.sheme.map(s=> {return s.sezona}).filter((v,i,s)=>s.indexOf(v)===i);
            
            for (let tmpsezona of this.sezonePisanje.map(s=>s.sezona))
             if(!sezone.find(s=>s==tmpsezona)){
               console.log("Dodajam sezone pravic:")
                console.log(sezone); 
                sezone.push(tmpsezona);
             }

             
            
            if (sezone)
                return sezone;
            else
                return [];

          }
        },
        izbraneSheme:
        {
            get()
            {
                if (!this.pridelovalec.sheme)
                return [];


                let sheme = this.pridelovalec.sheme.filter(s=>s.sezona==this.sezona&&(s.status=="aktiven"||s.jeaktivna)).map(s=> {
                    var s={kratica:s.shema};
                    return s});
                return sheme;
            }

        },
        kmgmid:{
          get() {
            return this.pridelovalec.kmgmid;
          },
          set(value) {
            this.updatekmgmid(value);
          }
        },
        ds:{
          get() {
            return this.pridelovalec.ds;
          },
          set(value) {
            this.updateds(value);
          }
        },
        emso:{
          get() {
            return this.pridelovalec.emso;
          },
          set(value) {
            this.updateemso(value);
          }
        },
         naziv:{
          get() {
            return this.pridelovalec.kontakt[0].naziv;
          },
          set(value) {
            this.updateprop({property:'naziv',value:value});
            this.updatekontaktprop({property:'naziv',value:value});
          }
        },
         naslov:{
          get() {
            return this.pridelovalec.kontakt[0].naslov;
          },
          set(value) {
            this.updateprop({property:'naslov',value:value});
            this.updatekontaktprop({property:'naslov',value:value});
          }
        },
        postnastevilka:{
          get() {
            return this.pridelovalec.kontakt[0].postnastevilka;
          },
          set(value) {
            this.updateprop({property:'postnastevilka',value:value});
            this.updatekontaktprop({property:'postnastevilka',value:value});
          }
        },
         posta:{
          get() {
            return this.pridelovalec.kontakt[0].posta;
          },
          set(value) {
            this.updateprop({property:'posta',value:value});
            this.updatekontaktprop({property:'posta',value:value});
          }
        }
        
    },
    mounted () {
      console.log("NALAGAM!!!")
      if(this.strankaid) {
       this.loadOne({sezona:this.$trenutnasezona,pridelovalecid:this.strankaid});
       console.log("NALožil stranko!!!")
      }
      else
       this.clear();
     
    },
    methods: {
        
        ...mapActions({naloziSifrant: 'sifrant/load'}),
          ...mapActions({clearAlert: 'alert/clear',error: 'alert/error',warning: 'alert/warning',success: 'alert/success'}),
        ...mapActions('pridelava',['loadbykmgmid','loadbyds','loadbyemso','clear','savekmg','loadOne']),
        ...mapMutations('pridelava',['updatekmgmid','updateds','updateemso','updateprop','updateshemaprop','updatekontaktprop','loadOneRKG']),
        
        async iscirkg(iskalnniniz,vrstaiskanja="kmgmid"){
          console.log("IŠČEM RKG")
          if(!(/\d{9}/).test(this.pridelovalec.kmgmid)){
            this.warning("KMG številka ni v pravilni obliki!");
            console.log(this.pridelovalec.kmgmid)
            console.log("NI VREDU KMG")
            return;
          }
          else{
            this.clearAlert();
            console.log("VREDU KMG")
          }
          

          this.iskanjeError=false;

    this.iscipodizvajalcaerror="";
    //var obstojecastranka=await pridelavaService.isciStranko(this.iscipodizvajalca?this.iscipodizvajalca:'');

  //if(obstojecastranka){
    //console.log("Stranka že obstaja")
    //this.iscipodizvajalcaerror="Že obstaja";
    //return;
    //}

    var rkgstranka=await pridelavaService.isciStrankoRKG(iskalnniniz?iskalnniniz:'',vrstaiskanja);
    if(rkgstranka.napaka){
      console.log("NAPAKA!!!")
      console.log(rkgstranka.napaka)
      this.warning(rkgstranka.napaka);
    }
    //this.iscipodizvajalcaerror="Že obstaja";
    else if(rkgstranka.stranka){
      //this.iskanjeError=true;
      var kontakt=rkgstranka.stranka.kontakt.find(k=>k.glavni);
      if(!kontakt)
        kontakt=rkgstranka.stranka.kontakt.find(k=>k.vloga=="sedež");
      if(!kontakt)
        kontakt=rkgstranka.stranka.kontakt.find(k=>k.vloga=="nosilec kmg");
      if(!kontakt)
          kontakt=rkgstranka.stranka.kontakt[0]
      this.error(rkgstranka.napaka + " "+kontakt.naziv );

      Vue.set(this.pridelovalec,"kontakt",rkgstranka.kontakt);
    Vue.set(this.pridelovalec,"kmgmid",rkgstranka.kmgmid)
    Vue.set(this.pridelovalec,"mso",rkgstranka.mso)
    Vue.set(this.pridelovalec,"emso",rkgstranka.emso)
    Vue.set(this.pridelovalec,"ds",rkgstranka.ds)
    delete this.pridelovalec._id;

    }
    else{    
      console.log("NI OK!!!")
    this.warning("Nisem našel osebe s to številko!");
    }
        


    //this.loadOneRKG(rkgstranka);

},



        dodajkontakt(){
            var k={
                glavni:false,
                naziv:"",
                naslov:"",
                postnastevilka:"",
                posta:"",
                telefon:[""],
                email:[""],
                vloga:"",
                spletnastran:"",
                drzava:"",
                kodadrzave:""
            }
            this.pridelovalec.kontakt.push(k);

        },
        brisikontakt(index){
            this.pridelovalec.kontakt.splice(index,1)

        },
        handleSubmit(e){

          e.preventDefault();
        },
        cancel(e){

          //kontrolna je prazna, preveri...

          //kliči save, izpiši error msg
          // v api poglej, če že ta ko ima mid, če ga ima, ga ne dodaj, javi mu aktivnost, mogoče daj link...
          //če že ima kera druga ko sedaj, ali ga je imela v preteklosti, javi 

          //potem idi naredit urejanje...
            this.$router.go(-1)
        },
        spremeniShemo (event)  {
            var sheme=event.value;
            //this.updateshemaprop({sezona:this.sezona,shema:"EKO PRI",property:"dejavnosti",value:[...event.target.value]});
            //this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"datumDolocitve",value:value.toISOString()});
            if(!this.pridelovalec.sheme)
                Vue.set(this.pridelovalec,'sheme',[]);
            for (let shema of this.sheme){
                if(sheme.find(s=>s.kratica==shema.kratica))
                {//gre za aktivno shemo če obstaja, jo daj v aktivno, če je ni, jo dodaj
                    console.log("Shemo " +shema.kratica+" dam na aktivno");
                    let obstojecaShema=this.pridelovalec.sheme.find(s=>s.shema==shema.kratica&&s.sezona==this.sezona);
                    if(obstojecaShema){
                        console.log("Shema " +shema.kratica+" že obstaja");
                        Vue.set( obstojecaShema, "jeaktivna",true);
                    }
                    else{
                        let novaShema={
                            datumPrijave: Date(),
                            dejavnosti: [],
                            dejavnostizadruge: [],
                            kontrolnaStevilka: "",
                            sezona: this.sezona,
                            shema: shema.kratica,
                            jeaktivna: true
                            }
                        this.pridelovalec.sheme.push(novaShema);
                        console.log("Shemo " +shema.kratica+" sem dodal na novo");
                    }
                                 
                }
                else
                {//Gre za neaktivno shemo... poglej, če je med shemami in jo daj v enakitvno
                    console.log("Shemo " +shema.kratica+" dam na neaktivno");
                    let obstojecaShema=this.pridelovalec.sheme.find(s=>s.shema==shema.kratica&&s.sezona==this.sezona);
                    if(obstojecaShema){
                        Vue.set( obstojecaShema, "jeaktivna",false);
                        //this.updateshemaprop({sezona:this.sezona,shema:shema.kratica,property:"status",value:"neaktiven"});
                    }
                }
            }
            console.log(this.pridelovalec.sheme);
            console.log(this.izbraneSheme);
            
        },
        
     

        async saveData(e){

         
          //kontrolna je prazna, preveri...

          //kliči save, izpiši error msg
          // v api poglej, če že ta ko ima mid, če ga ima, ga ne dodaj, javi mu aktivnost, mogoče daj link...
          //če že ima kera druga ko sedaj, ali ga je imela v preteklosti, javi 

          if(!(/\d{9}/).test(this.pridelovalec.kmgmid)){
            this.warning("KMG številka ni v pravilni obliki!");
            console.log(this.pridelovalec.kmgmid)
            console.log("NI VREDU KMG")
            return;
          }
          else{
            this.clearAlert();
          }

          var rkgstranka=await pridelavaService.isciStrankoRKG(this.pridelovalec.mso?this.pridelovalec.mso:'');
          //stranka je že noter z mso!!!
          if(rkgstranka.stranka&&rkgstranka.stranka._id!=this.pridelovalec._id){
             var kontakt=rkgstranka.stranka.kontakt.find(k=>k.glavni);
             if(!kontakt)
                kontakt=rkgstranka.stranka.kontakt.find(k=>k.vloga=="sedež");
              if(!kontakt)
                kontakt=rkgstranka.stranka.kontakt.find(k=>k.vloga=="nosilec kmg");
              if(!kontakt)
                  kontakt=rkgstranka.stranka.kontakt[0]
              this.error(rkgstranka.napaka + " "+kontakt.naziv + " MSO: "+rkgstranka.stranka.mso);
             
              return;
            }

            rkgstranka=await pridelavaService.isciStrankoRKG(this.pridelovalec.kmgmid?this.pridelovalec.kmgmid:'');
          //stranka je že noter z kmg!!!
          if(rkgstranka.stranka&&rkgstranka.stranka._id!=this.pridelovalec._id){
             var kontakt=rkgstranka.stranka.kontakt.find(k=>k.glavni);
             if(!kontakt)
                kontakt=rkgstranka.stranka.kontakt.find(k=>k.vloga=="sedež");
              if(!kontakt)
                kontakt=rkgstranka.stranka.kontakt.find(k=>k.vloga=="nosilec kmg");
              if(!kontakt)
                  kontakt=rkgstranka.stranka.kontakt[0]
              this.error(rkgstranka.napaka + " "+kontakt.naziv + " KMGMID: "+rkgstranka.stranka.kmgmid );
              return;
            }

            rkgstranka=await pridelavaService.isciStrankoRKG(this.pridelovalec.davcnastevilka?this.pridelovalec.davcnastevilka:'');
          //stranka je že noter z ds!!! primerjamo 
          if(rkgstranka.stranka&&rkgstranka.stranka._id!=this.pridelovalec._id){
            if(rkgstranka.stranka.mso==this.pridelovalec.mso) {
             var kontakt=rkgstranka.stranka.kontakt.find(k=>k.glavni);
             if(!kontakt)
                kontakt=rkgstranka.stranka.kontakt.find(k=>k.vloga=="sedež");
              if(!kontakt)
                kontakt=rkgstranka.stranka.kontakt.find(k=>k.vloga=="nosilec kmg");
              if(!kontakt)
                  kontakt=rkgstranka.stranka.kontakt[0]
              this.error(rkgstranka.napaka + " "+kontakt.naziv + " MSO: "+rkgstranka.stranka.mso );
               alert("pre return");
              return;
            }
          }

        
//tukaj pošlji vse podatke!!!
//če je bila napaka, potem ne shrani!!!?
            console.log("shranjujem!");
            console.log(this.pridelovalec)
            if(this.dataValid)
            {
            
              
            this.savekmg({kontrolnastevilka:this.kontrolnastevilka,...this.dataSezona}).then(
              data=>{
                console.log(data);
               this.dataValid=false;
              },
              error=>{

              console.log(error);
              }
              )
              
            }
            
          //potem idi naredit urejanje...
            
        },
           kntChange(e){
            this.clearAlert();
        },
          dataChange(e){
            this.dataValid=true;
        },
        loadDataKmgmid (e) {
          //preveri in daj error
          //d{9}
         //tole smao na enter in brezveze...
          this.loadbykmgmid(this.pridelovalec);
            this.dataValid=true;
         
          
        },
        loadDataEmso (e) {

          this.loadbyemso(this.pridelovalec);
          this.dataValid=true;


          
        },
        loadDataDs (e) {
              this.dataValid=true;
             this.loadbyds(this.pridelovalec);
             

          
        },
        naloziPodatke (){
             //this.dataSezona={sezona:this.sezona};
       // this.dataSezone
//         this.sifrant["statuspridelovalca"]
  //       this.sifrant["vrstapridelovalca"]
          

        },
         sezonaChange(event) {
            const sezona = event.value;
            this.sezona=sezona;
           // this.naloziPodatke();



        },
    }
};
</script>

<style>
form {
display:flex;
flex-direction:column;
}


</style>